@import "tailwindcss";

/* ── CSS Custom Properties ─────────────────────────────────────────────── */
/* Font faces are injected at runtime via useFontInjection hook             */
/* using window.campaignParams.assetsUrl to resolve the correct plugin URL  */

:root {
  --color-primary: #1a6fad;
  --color-accent: #e62e2e;
  --color-bg: #fdf8f3;
  --color-card: #ffffff;
  --color-text: #2d2d2d;
  --color-text-muted: #6b7280;
  --font-body: 'FbAsli', 'Arial Hebrew', sans-serif;
  --font-heading: 'FbShefa', 'Arial Hebrew', sans-serif;
  --font-display: 'LiaShokolad', 'Arial Hebrew', sans-serif;
  --font-ui: 'Almoni', 'Arial Hebrew', sans-serif;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  font-family: var(--font-body);
  color: var(--color-text);
  direction: rtl;
  margin: 0;
}

#leahles-children-campaign {
  font-family: var(--font-body);
  direction: rtl;
}
